import * as Sentry from '@sentry/react';

import { REPORT_ERRORS_REMOTELY, REPORT_ERRORS_TO_CONSOLE } from '../../config';

export function logErrorService(error: any, info?: any) {
  if (Sentry.captureException && REPORT_ERRORS_REMOTELY === 'true') {
    if (info !== undefined) {
      Sentry.captureException(error, { extra: { info } });
    } else {
      Sentry.captureException(error);
    }
  } else if (REPORT_ERRORS_TO_CONSOLE === 'true') {
    if (info !== undefined) {
      console.error(error, info);
    } else {
      console.error(error);
    }
  }
}
